import JourneyWarningMessage from '@/components/purchase/journey/JourneyWarningMessage';
import { TransText } from '@/i18n/trans/text';
import type { OffersWarning } from '@/types/offer';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface JourneyOfferWarningsProps {
  warnings?: OffersWarning[];
}

const JourneyOfferWarnings: FC<JourneyOfferWarningsProps> = ({ warnings }) => {
  if (!warnings?.length) {
    return null;
  }

  return (
    <div
      className="flex flex-col gap-3 rounded border border-warning-border bg-warning-surface p-3 text-dark"
      data-testid="journey-offer-warnings"
    >
      <div className="flex gap-3">
        <Icons.alertCircle height={20} width={20} />
        <Typography variant="subtitle">
          <TransText i18nKey="importantInformation" />
        </Typography>
      </div>
      {warnings.map((warning, key) => (
        <Typography
          key={`${warning.code ?? warning.detail ?? 'warning'}-${key}`}
          variant="paragraph"
          as="div"
        >
          <JourneyWarningMessage warning={warning} />
        </Typography>
      ))}
    </div>
  );
};

export default JourneyOfferWarnings;
